import React from 'react';
import AnalysisTextSection from './AnalysisTextSection';
import { Registry } from '@/graphql/__generated__/onboarding';
import { useNormalizedAntifraudData } from '@/hooks/useNormalizedAntifraudData';
import { NormalizedAntifraudData } from '@/utils/antifraudDataNormalizer';

interface GeolocationAddressProps {
	registry: Registry;
	normalizedData?: NormalizedAntifraudData | null;
}

export const GeolocationAddress: React.FC<GeolocationAddressProps> = ({
	registry,
	normalizedData: propNormalizedData
}) => {
	const hookNormalizedData = useNormalizedAntifraudData(registry);
	const normalizedData = propNormalizedData ?? hookNormalizedData;

	return (
		<div className="space-y-3">
			<AnalysisTextSection
				label="ValidatedFullAddress"
				value={normalizedData?.address?.validatedFullAddress}
			/>
		</div>
	);
};

export default GeolocationAddress;
